export function setBrowserScrollbarWidth() {
	const { documentElement } = document;
	const scrollbarWidth = getScrollbarWidth();
	documentElement.style.setProperty("--scrollbar-width", `${scrollbarWidth}px`);
}

function getScrollbarWidth() {
	return window.innerWidth - document.documentElement.clientWidth;
}
